import { NostrEvent } from '@nostr/tools/core'
import { Content } from '@tiptap/react'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { sha256 } from '@noble/hashes/sha2.js'
import { SelectableItem } from '../RelaySelector'
import { PrimitiveAtom } from 'jotai'

export type TComposerState = {
  nsfw: boolean
  quietReply: boolean
  protected: boolean
  premium: boolean
  relaySelection: SelectableItem[]
  content: Content
}

const composerStates = new Map<string, PrimitiveAtom<TComposerState>>()

function getComposerStateKey(
  defaultContent: string,
  parentEvents: undefined | NostrEvent[],
  openFromRelay: string[] | undefined
): string {
  let key = parentEvents?.map((pe) => pe.id).join(',') || 'new'
  if (defaultContent) key += '/' + sha256(new TextEncoder().encode(defaultContent))
  if (openFromRelay?.length) key += '/r:' + [...openFromRelay].sort().join(',')
  return key
}

export function getComposerStateAtom(
  defaultContent: string,
  parentEvents: undefined | NostrEvent[],
  openFromRelay: string[] | undefined,
  init: () => TComposerState,
  initialState?: TComposerState
): PrimitiveAtom<TComposerState> {
  const key = getComposerStateKey(defaultContent, parentEvents, openFromRelay)
  const composerState = composerStates.get(key)
  if (composerState) return composerState

  const storage = createJSONStorage<TComposerState>(() => window.sessionStorage)
  const initial = initialState ?? init()
  const atom = atomWithStorage<TComposerState>(`pec:${key}`, initial, storage)

  composerStates.set(key, atom)

  return atom
}

export function removeComposerState(
  defaultContent: string,
  parentEvents: undefined | NostrEvent[],
  openFromRelay: string[] | undefined
) {
  const key = getComposerStateKey(defaultContent, parentEvents, openFromRelay)
  composerStates.delete(key)
  window.sessionStorage.removeItem(`pec:${key}`)
}
